module.exports = __webpack_public_path__ + "media/images/map_mass_bay_colony-7e23a49fa4d313cb1e6435d27e360443.jpg";